export const SELECT_DEFAULT_VALUE = 'all';

export const selectDefault = { value: SELECT_DEFAULT_VALUE, label: 'ALL' };
